import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useFetchUser from './useFetchUser';
import useTokenExpiryCheck from './useTokenExpiryCheck';

const PrivateRoute = ({ children, path, ...rest }) => {
  const decoded = useTokenExpiryCheck();
  // const [error, loading] = useFetchCustomer();
  useFetchUser();

  return (
    <Route
      path={path}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={({ location }) =>
        decoded ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.node.isRequired,
};

export default PrivateRoute;
